const React = require('react');
const ReactIntl = require('react-intl');
const _ = require('lodash');

const { Separator } = require('@metro-ui/core');
const { Button } = require("metro-ui-components");

const PageCase = require("../PageCase/PageCase.js");
const Header = require("../Header/Header");
const Footer = require("../Footer/Footer");
const LoginBoxWrapper = require("../LoginBoxWrapper/LoginBoxWrapper.js");
const PasswordField = require("../Password/PasswordField.js");

const LoginStore = require("../../stores/LoginStore");
const LoginActions = require('../../actions/LoginActions.js');

const defaultMessages = require('../../i18n/messages/default');
const urlUtils = require('../../utils/urlUtils.js');
const Constants = require('../../constants/AppConstants');

const { injectIntl, IntlProvider } = ReactIntl;
class Consent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            localeId: 'en-GB',
            redirectUri: ''
        };

        this.onLocalChange = this.onLocalChange.bind(this);
        this.onConsentSubmit = this.onConsentSubmit.bind(this);
        this.onConsentHDListener = this.onConsentHDListener.bind(this);
    }

    getQueryParamsMapped() {
        return {
            clientId: urlUtils.getParameterByName(Constants.UrlParams.CLIENT_ID),
            localeId: urlUtils.getParameterByName(Constants.UrlParams.LOCALE_ID),
            loginId: urlUtils.getParameterByName(Constants.UrlParams.LOGIN_ID),
            userType: urlUtils.getParameterByName(Constants.UrlParams.USER_TYPE),
            countryCode: urlUtils.getParameterByName(Constants.UrlParams.COUNTRY_CODE),
            consent: urlUtils.getParameterByName(Constants.UrlParams.CONSENT),
            consentCode: urlUtils.getParameterByName(Constants.UrlParams.CONSENT_CODE),
        }
    }

    componentDidMount() {
        LoginStore.addConsentHDListener(this.onConsentHDListener);

        const consentUriData = this.getQueryParamsMapped()

        this.setState({ ...consentUriData });
    }

    onConsentHDListener() {
        const appState = LoginStore.getState();
        const { consent: { error, responseCode, result } } = appState;

        if (error) {
            switch (responseCode) {
                case 401:
                    LoginActions.triggerToast(
                        this.props.intl.formatMessage(defaultMessages['invalid_credentials']),
                        "error", true);
                    break;
                case 500:
                    LoginActions.triggerToast(
                        this.props.intl.formatMessage(defaultMessages['badrequest']),
                        "error", true);
                    break;
            }
        } else {
            LoginActions.triggerToast(
                this.props.intl.formatMessage(defaultMessages['success']),
                "success", true);

            window.location = result.url
        }
    }

    onConsentSubmit(event) {
        const { loginId, userType, clientId, countryCode, consentCode } = this.state;
        event.preventDefault();

        LoginActions.submitConsentHD(loginId, userType, clientId, countryCode, true, consentCode);
    }

    onLocalChange(localeId) {
        this.setState({ localeId });
    }

    componentWillUnmount() {
        LoginStore.removeConsentHDListener(this.onConsentHDListener)
    }

    renderConsentContent() {
        const { intl: { formatMessage } } = this.props;

        return (
            <div>
                <div className="linkAccount container">
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                    <div className="col-md-6 col-sm-8 col-xs-12 larger-device-width">
                        <div className="row whiteContainer newDesign larger-device-width smaller-device">
                            <div className="col-xs-12 smaller-device-inside-wrap loginCard">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="centreAligned">
                                            <span className="consentTitle">
                                                {formatMessage(defaultMessages["linkAccount.consent.title"])}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <LoginBoxWrapper>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="consentListWrapper">
                                                <ul>
                                                    <li>
                                                        {formatMessage(
                                                            defaultMessages["linkAccount.consent.description_1"]
                                                        )}
                                                    </li>
                                                    <li>
                                                        {formatMessage(
                                                            defaultMessages["linkAccount.consent.description_2"]
                                                        )}
                                                    </li>
                                                    <li>
                                                        {formatMessage(
                                                            defaultMessages["linkAccount.consent.description_3"]
                                                        )}
                                                    </li>
                                                    <li>
                                                        {formatMessage(
                                                            defaultMessages["linkAccount.consent.description_4"]
                                                        )}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <Button
                                            id="submit"
                                            type="submit"
                                            value="submit"
                                            kind="primaryRaised"
                                            size="large"
                                            className="primary-button"
                                            onClick={this.onConsentSubmit}
                                        >
                                            {formatMessage(
                                                defaultMessages["linkAccount.consent.action"])
                                            } {this.state.loginId}
                                        </Button>
                                        <div className="separatorWidth">
                                            <Separator />
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group centreAligned consentLinksText">
                                                    <span>
                                                        {`${formatMessage(
                                                            defaultMessages["linkAccount.consent.terms_1"])
                                                        } `}
                                                    </span>
                                                    <a href={Constants.SOCIAL_LOGIN.DISH_CONSTANTS.termsAndConditionsLink}>
                                                        {formatMessage(
                                                            defaultMessages["linkAccount.consent.terms_2"]
                                                        )}
                                                    </a>
                                                    <span>
                                                        {` ${formatMessage(
                                                            defaultMessages["linkAccount.consent.terms_3"])
                                                        } `}
                                                    </span>
                                                    <a href={Constants.SOCIAL_LOGIN.DISH_CONSTANTS.privacyPolicyLink}>
                                                        {formatMessage(
                                                            defaultMessages["linkAccount.consent.terms_4"]
                                                        )}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </LoginBoxWrapper>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-2 col-xs-0" />
                </div>
            </div>
        );
    }

    renderFooter() {
        return (
            <IntlProvider
                locale={this.state.localeId}
                messages={this.props.translations}
            >
                <div className="fixFooterBottom">
                    <Footer
                        {...this.props}
                        locale={this.state.localeId}
                        onLocalChange={this.onLocalChange}
                    />
                </div>
            </IntlProvider>
        );
    };

    render() {
        return (
            <PageCase
                header={<Header removeNavbar />}
                content={this.renderConsentContent()}
                footer={this.renderFooter()}
            />
        );
    }
}

module.exports = injectIntl(Consent);
